import { Input, Modal, ModalProps } from 'antd';

type Props = ModalProps & {
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  inputValue: string;
  onInputChange: (value: string) => void;
}

const SaveFilterModal = ({ inputValue, onCancel, onInputChange, onOk, open, ...modalProps }: Props) => {
  return <Modal
    {...modalProps}
    onOk={onOk}
    onCancel={onCancel}
    open={open}
    afterOpenChange={() => document.getElementById('filter-name-input')?.focus()}
  >
    <Input id='filter-name-input' placeholder='Add a name to the filter' value={inputValue} onChange={(e) => onInputChange(e.target.value)} onPressEnter={onOk} />
  </Modal>
}

export default SaveFilterModal